import React, { FC, memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../../../auth/auth-provider';
import { localized, localizedInterpolation } from '../../../../i18n/i18n';
import { selectOrganization } from '../../../../state/features/settings/settings-slice';
import { AddNewButton } from '../../../components/specific-components/buttons/add-new-button';
import { useRightSidebar } from '../../../components/specific-components/right-side-bar';
import { CreateOrganizationForm } from './create-organization';
import { getUsers } from '../../../../state/features/users/operation';
import { getDevicesFull } from '../../../../state/features/devices/operation';

export const GlobalAdminOrganizationButtons: FC = memo(() => {
  const { isGlobalAdmin } = useAuth();
  const dispatch = useDispatch();
  const selectedOrganization = useSelector(selectOrganization);
  const setSidebarContent = useRightSidebar();

  const onNewOrganization = useCallback(() => {
    setSidebarContent(<CreateOrganizationForm />);
  }, [setSidebarContent]);

  const onEditOrganization = useCallback(() => {
    setSidebarContent(<CreateOrganizationForm existingOrganization={selectedOrganization} />);
  }, [selectedOrganization, setSidebarContent]);

  useEffect(() => {
    setSidebarContent(null);
    if (selectedOrganization) {
      dispatch(getUsers(selectedOrganization.id));
      dispatch(getDevicesFull(selectedOrganization.id));
    }
  }, [dispatch, selectedOrganization, setSidebarContent]);

  return (
    <>
      {isGlobalAdmin && (
        <>
          <AddNewButton onClick={onEditOrganization} isEdit>
            {localizedInterpolation('EditInt', {
              area: localized('Organization').toLocaleLowerCase(),
            })}
          </AddNewButton>
          <AddNewButton onClick={onNewOrganization}>
            {localizedInterpolation('AddNewInt', {
              area: localized('Organization').toLocaleLowerCase(),
            })}
          </AddNewButton>
        </>
      )}
    </>
  );
});
